// src/components/ReviewsCTA.js
import React from "react";

export default function ReviewsCTA({
  href,
  text = "Laisser un avis sur Google",
  className = "",
  showHint = false, // par défaut : pas de texte "redirection" (plus clean en footer)
}) {
  // Valide doucement l'URL (sans jamais throw)
  const parsed = (() => {
    try {
      if (!href) return null;
      const u = new URL(href, window.location.origin);
      return /^https?:$/.test(u.protocol) ? u.toString() : null;
    } catch {
      return null;
    }
  })();

  // Fallback si href invalide/absent : renvoie vers la recherche Google de la fiche
  const fallback =
    "https://www.google.com/search?q=HLBK+Photographe+Tomblaine#reviews";

  const finalHref = parsed || fallback;
  const shouldShowHint = showHint && !parsed;

  return (
    <div className={`reviews-cta ${className}`}>
      <a
        href={finalHref}
        target="_blank"
        rel="noreferrer"
        className="reviews-cta__btn"
        aria-label={text}
        title={text}
      >
        ★ {text}
      </a>

      {shouldShowHint && (
        <p className="reviews-cta__hint">
          (Redirection vers la page Google si le lien direct n’est pas disponible)
        </p>
      )}
    </div>
  );
}